module.exports = __webpack_public_path__ + "static/img/logo-b.535481a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo-b.png
// module id = 2JXE
// module chunks = 2